import { graphql } from '@/gql';
import type { OperatorActivityInputType } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateOperatorActivity = async ({ id, data }: { id: string; data: OperatorActivityInputType }) => {
  const response = await mutationExecute({
    variables: {
      data,
      id,
    },
    mutation: graphql(`
      mutation UpdateOperatorActivity($data: OperatorActivityInputType!, $id: String!) {
        updateOperatorActivity(data: $data, id: $id) {
          id
        }
      }
    `),
  });

  return response.data?.updateOperatorActivity!;
};
